/* @ngInject */
function CategoryFilterParentItemController () {
  var ctrl = this

  ctrl.selectCategory = function ($event, category) {
    $event.stopPropagation()
    $event.stopImmediatePropagation()
    ctrl.onChange({ category: category })
  }
}

export { CategoryFilterParentItemController }
